<script setup lang="ts">
/*
* v-html for headline text is needed for sweepstakes hack to allow brand image above headline
* */
const props = defineProps<{
  text?: string
  seeding?: { enabled?: boolean, headlineId?: string }
}>()

const setSeedingHeadlineId = () =>
  (props.seeding?.enabled && (props.seeding.headlineId?.length ?? 0) > 0) ? props.seeding.headlineId : undefined // falsy value removes the attribute
</script>

<template>
  <h1 :id="setSeedingHeadlineId()"
      class="bx-content bx-content__headline bx-typo--content-headline"
      v-html="text" />
</template>
